import { Link } from "react-router-dom";
import { LINKS } from "../lib/config";
import { motion } from "framer-motion";

export default function Footer({ onBook }) {
    return (
        <footer className="relative bg-ink text-white pt-20 md:pt-32 pb-8 overflow-hidden">
            <div className="max-w-[1600px] mx-auto px-5 md:px-12">
                <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                    className="font-serif font-bold leading-[0.85] tracking-tight text-[18vw] md:text-[15vw] lg:text-[13vw]"
                >
                    Let&apos;s <span className="italic text-fuchsia">train.</span>
                </motion.h2>

                <div className="mt-16 md:mt-24 grid md:grid-cols-4 gap-10 border-t border-white/10 pt-10 md:pt-14">
                    <div>
                        <div className="mb-4">
                            <span className="brand-wordmark text-4xl text-white">
                                <span className="text-fuchsia">#</span>CoachAmy
                            </span>
                        </div>
                        <p className="font-sans text-white/60 text-sm leading-relaxed">
                            Personal Trainer e Coach delle Gravidanze. Allenamenti su misura, in presenza e online.
                        </p>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">Naviga</p>
                        <ul className="space-y-2 font-sans text-sm">
                            <li><Link to="/" className="editorial-link">Home</Link></li>
                            <li><Link to="/chi-sono" className="editorial-link">Chi sono</Link></li>
                            <li><a href="/#percorsi" className="editorial-link">Percorsi</a></li>
                            <li><a href="/#contact" className="editorial-link">Contatti</a></li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">Contatti</p>
                        <ul className="space-y-2 font-sans text-sm">
                            <li><a href={LINKS.instagram} className="editorial-link">Instagram</a></li>
                            <li><a href={LINKS.whatsapp} className="editorial-link">WhatsApp</a></li>
                            <li><a href={LINKS.email} className="editorial-link">Email</a></li>
                            <li>
                                <button onClick={onBook} data-testid="footer-book-btn" className="editorial-link text-left">
                                    Prenota una consulenza (in presenza o online)
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">Legal</p>
                        <ul className="space-y-2 font-sans text-sm">
                            <li><Link to="/privacy-policy" className="editorial-link" data-testid="footer-privacy">Privacy Policy</Link></li>
                            <li><Link to="/cookie-policy" className="editorial-link" data-testid="footer-cookie">Cookie Policy</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs font-sans text-white/40 border-t border-white/10 pt-8">
                    <p>© {new Date().getFullYear()} #CoachAmy. Tutti i diritti riservati.</p>
                    <p>Personal trainer · fitness · gravidanza · post parto</p>
                </div>
            </div>
        </footer>
    );
}
